function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { e as Connector, m as _classPrivateMethodInitSpec, _ as _defineProperty, j as _classPrivateFieldInitSpec, n as normalizeChainId, o as _classPrivateMethodGet, U as UserRejectedRequestError, k as _classPrivateFieldGet, l as _classPrivateFieldSet, i as SwitchChainError } from '../../../dist/base-b565d5d4.esm.js';
import { providers } from 'ethers';
import { getAddress, hexValue } from 'ethers/lib/utils';
import { g as getClient } from '../../../dist/client-a05fd511.esm.js';
import 'eventemitter3';
import '../../../dist/chains-fd2c546c.esm.js';
import '../../../dist/rpcs-b73a8f60.esm.js';
import 'zustand/vanilla';
import 'zustand/middleware';
/**
 * Wallets that support chain switching through WalletConnect
 * - imToken (token.im)
 * - MetaMask (metamask.io)
 * - Rainbow (rainbow.me)
 */

var switchChainAllowedRegex = /(imtoken|metamask|rainbow)/i;

var _provider = /*#__PURE__*/new WeakMap();

var _switchChain = /*#__PURE__*/new WeakSet();

var WalletConnectConnector = /*#__PURE__*/function (_Connector) {
  _inherits(WalletConnectConnector, _Connector);

  var _super = _createSuper(WalletConnectConnector);

  function WalletConnectConnector(config) {
    var _this;

    _classCallCheck(this, WalletConnectConnector);

    _this = _super.call(this, config);

    _classPrivateMethodInitSpec(_assertThisInitialized(_this), _switchChain);

    _defineProperty(_assertThisInitialized(_this), "id", 'walletConnect');

    _defineProperty(_assertThisInitialized(_this), "name", 'WalletConnect');

    _defineProperty(_assertThisInitialized(_this), "ready", true);

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _provider, {
      writable: true,
      value: void 0
    });

    _defineProperty(_assertThisInitialized(_this), "onAccountsChanged", function (accounts) {
      if (accounts.length === 0) _this.emit('disconnect');else _this.emit('change', {
        account: getAddress(accounts[0])
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChainChanged", function (chainId) {
      var id = normalizeChainId(chainId);

      var unsupported = _this.isChainUnsupported(id);

      _this.emit('change', {
        chain: {
          id: id,
          unsupported: unsupported
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDisconnect", function () {
      _this.emit('disconnect');
    });

    return _this;
  }

  _createClass(WalletConnectConnector, [{
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var _ref,
            chainId,
            _provider$connector$p,
            _provider$connector,
            _provider$connector$p2,
            targetChainId,
            lastUsedChainId,
            provider,
            accounts,
            account,
            id,
            unsupported,
            walletName,
            _args = arguments;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, chainId = _ref.chainId;
                _context.prev = 1;
                targetChainId = chainId;

                if (!targetChainId) {
                  lastUsedChainId = getClient().lastUsedChainId;
                  if (lastUsedChainId && !this.isChainUnsupported(lastUsedChainId)) targetChainId = lastUsedChainId;
                }

                _context.next = 6;
                return this.getProvider({
                  chainId: targetChainId,
                  create: true
                });

              case 6:
                provider = _context.sent;
                provider.on('accountsChanged', this.onAccountsChanged);
                provider.on('chainChanged', this.onChainChanged);
                provider.on('disconnect', this.onDisconnect); // Defer message to the next tick to ensure wallet connect data (provided by `.enable()`) is available

                setTimeout(function () {
                  return _this2.emit('message', {
                    type: 'connecting'
                  });
                }, 0);
                _context.next = 13;
                return provider.enable();

              case 13:
                accounts = _context.sent;
                account = getAddress(accounts[0]);
                _context.next = 17;
                return this.getChainId();

              case 17:
                id = _context.sent;
                unsupported = this.isChainUnsupported(id); // Not all WalletConnect options support programmatic chain switching
                // Only enable for wallet options that do

                walletName = (_provider$connector$p = (_provider$connector = provider.connector) === null || _provider$connector === void 0 ? void 0 : (_provider$connector$p2 = _provider$connector.peerMeta) === null || _provider$connector$p2 === void 0 ? void 0 : _provider$connector$p2.name) !== null && _provider$connector$p !== void 0 ? _provider$connector$p : '';
                if (switchChainAllowedRegex.test(walletName)) this.switchChain = _classPrivateMethodGet(this, _switchChain, _switchChain2);
                return _context.abrupt("return", {
                  account: account,
                  chain: {
                    id: id,
                    unsupported: unsupported
                  },
                  provider: new providers.Web3Provider(provider)
                });

              case 24:
                _context.prev = 24;
                _context.t0 = _context["catch"](1);

                if (!/user closed modal/i.test(_context.t0.message)) {
                  _context.next = 28;
                  break;
                }

                throw new UserRejectedRequestError(_context.t0);

              case 28:
                throw _context.t0;

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 24]]);
      }));

      function connect() {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "disconnect",
    value: function () {
      var _disconnect = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var provider;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getProvider();

              case 2:
                provider = _context2.sent;
                _context2.next = 5;
                return provider.disconnect();

              case 5:
                provider.removeListener('accountsChanged', this.onAccountsChanged);
                provider.removeListener('chainChanged', this.onChainChanged);
                provider.removeListener('disconnect', this.onDisconnect);
                typeof localStorage !== 'undefined' && localStorage.removeItem('walletconnect');

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function disconnect() {
        return _disconnect.apply(this, arguments);
      }

      return disconnect;
    }()
  }, {
    key: "getAccount",
    value: function () {
      var _getAccount = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var provider, accounts;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.getProvider();

              case 2:
                provider = _context3.sent;
                accounts = provider.accounts; // return checksum address

                return _context3.abrupt("return", getAddress(accounts[0]));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getAccount() {
        return _getAccount.apply(this, arguments);
      }

      return getAccount;
    }()
  }, {
    key: "getChainId",
    value: function () {
      var _getChainId = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var provider, chainId;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.getProvider();

              case 2:
                provider = _context4.sent;
                chainId = normalizeChainId(provider.chainId);
                return _context4.abrupt("return", chainId);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getChainId() {
        return _getChainId.apply(this, arguments);
      }

      return getChainId;
    }()
  }, {
    key: "getProvider",
    value: function () {
      var _getProvider = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _ref2,
            chainId,
            create,
            _this$options,
            _this$options2,
            rpc,
            WalletConnectProvider,
            _args5 = arguments;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _ref2 = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {}, chainId = _ref2.chainId, create = _ref2.create; // Force create new provider

                if (!(!_classPrivateFieldGet(this, _provider) || chainId || create)) {
                  _context5.next = 7;
                  break;
                }

                rpc = !((_this$options = this.options) !== null && _this$options !== void 0 && _this$options.infuraId) ? this.chains.reduce(function (rpc, chain) {
                  return _objectSpread(_objectSpread({}, rpc), {}, _defineProperty2({}, chain.id, chain.rpcUrls["default"]));
                }, {}) : {};
                _context5.next = 5;
                return import('@walletconnect/ethereum-provider');

              case 5:
                WalletConnectProvider = _context5.sent["default"];

                _classPrivateFieldSet(this, _provider, new WalletConnectProvider(_objectSpread(_objectSpread({}, this.options), {}, {
                  chainId: chainId,
                  rpc: _objectSpread(_objectSpread({}, rpc), (_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : _this$options2.rpc)
                })));

              case 7:
                return _context5.abrupt("return", _classPrivateFieldGet(this, _provider));

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getProvider() {
        return _getProvider.apply(this, arguments);
      }

      return getProvider;
    }()
  }, {
    key: "getSigner",
    value: function () {
      var _getSigner = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _ref3,
            chainId,
            _yield$Promise$all,
            _yield$Promise$all2,
            provider,
            account,
            _args6 = arguments;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _ref3 = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {}, chainId = _ref3.chainId;
                _context6.next = 3;
                return Promise.all([this.getProvider({
                  chainId: chainId
                }), this.getAccount()]);

              case 3:
                _yield$Promise$all = _context6.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                provider = _yield$Promise$all2[0];
                account = _yield$Promise$all2[1];
                return _context6.abrupt("return", new providers.Web3Provider(provider).getSigner(account));

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getSigner() {
        return _getSigner.apply(this, arguments);
      }

      return getSigner;
    }()
  }, {
    key: "isAuthorized",
    value: function () {
      var _isAuthorized = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var account;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return this.getAccount();

              case 3:
                account = _context7.sent;
                return _context7.abrupt("return", !!account);

              case 7:
                _context7.prev = 7;
                _context7.t0 = _context7["catch"](0);
                return _context7.abrupt("return", false);

              case 10:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 7]]);
      }));

      function isAuthorized() {
        return _isAuthorized.apply(this, arguments);
      }

      return isAuthorized;
    }()
  }]);

  return WalletConnectConnector;
}(Connector);

function _switchChain2(_x) {
  return _switchChain3.apply(this, arguments);
}

function _switchChain3() {
  _switchChain3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(chainId) {
    var provider, id, _this$chains$find, message;

    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return this.getProvider();

          case 2:
            provider = _context8.sent;
            id = hexValue(chainId);
            _context8.prev = 4;
            _context8.next = 7;
            return provider.request({
              method: 'wallet_switchEthereumChain',
              params: [{
                chainId: id
              }]
            });

          case 7:
            return _context8.abrupt("return", (_this$chains$find = this.chains.find(function (x) {
              return x.id === chainId;
            })) !== null && _this$chains$find !== void 0 ? _this$chains$find : {
              id: chainId,
              name: "Chain ".concat(id),
              network: "".concat(id),
              rpcUrls: {
                "default": ''
              }
            });

          case 10:
            _context8.prev = 10;
            _context8.t0 = _context8["catch"](4);
            message = typeof _context8.t0 === 'string' ? _context8.t0 : _context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message;

            if (!/user rejected request/i.test(message)) {
              _context8.next = 15;
              break;
            }

            throw new UserRejectedRequestError(_context8.t0);

          case 15:
            throw new SwitchChainError(_context8.t0);

          case 16:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, this, [[4, 10]]);
  }));
  return _switchChain3.apply(this, arguments);
}

export { WalletConnectConnector };